import {CommonTypes} from 'neo-common';
import {ClientHostConsumerBase} from '../../ClientHost/ClientHostConsumerBase';
import {AutoplayAction, ClientHostDialogRequest, ClientHostDispatchExitRequest, ClientHostPaytableRequest, GamePlayAction} from '../../ClientHost/Types';
import {IApp} from '../IApp';
import {IBalance} from '../../Communication/Game/Types/IBalance';

export abstract class PaytableClientHostConsumerBase extends ClientHostConsumerBase {
    constructor(app: IApp) {
        super(app);
    }

    handleAction(actionGroup: string, action: string): void {
        // NOTE(psulek) do not handle game stuff here from paytable!
        // Reserved for future use!
    }

    handleExit(request: ClientHostDispatchExitRequest, callback: CommonTypes.ErrorFunction): void {
        // NOTE(psulek) do not handle game stuff here from paytable!
        // Reserved for future use!
    }

    handleAccountUpdate(balance: IBalance, forceShow: boolean): void {
        // NOTE(psulek) do not handle game stuff here from paytable!
        // Reserved for future use!
    }

    handleRefreshAccount(): void {
        // NOTE(psulek) do not handle game stuff here from paytable!
        // Reserved for future use!
    }

    handleError(error: string, data?: any): void {
        // NOTE(psulek) do not handle game stuff here from paytable!
        // Reserved for future use!
    }

    handleShowDialog(request: ClientHostDialogRequest): void {
        // NOTE(psulek) do not handle game stuff here from paytable!
        // Reserved for future use!
    }

    handleCloseDialog(): void {
        // NOTE(psulek) do not handle game stuff here from paytable!
        // Reserved for future use!
    }

    handlePaytableRequest(request: ClientHostPaytableRequest): void {
        // NOTE(psulek) do not handle game stuff here from paytable!
        // Reserved for future use!
    }

    handleAutoplayAction(action: AutoplayAction): void {
        // NOTE(psulek) do not handle game stuff here from paytable!
        // Reserved for future use!
    }

    handleGameplayAction(action: GamePlayAction): void {
        // NOTE(psulek) do not handle game stuff here from paytable!
        // Reserved for future use!
    }

    handleBlockRequest(blocked: boolean): void {
        // NOTE(psulek) do not handle game stuff here from paytable!
        // Reserved for future use!
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/GameEngine/Paytable/PaytableClientHostConsumerBase.ts
 **/